<template>
  <div class="layer-popup-container">
    <div class="layer-popup type02" id="popup-notice">
      <div>
        <div class="popup-wrapper">
          <div class="popup-body">
            <div id="popup-notice-image">
              <div class="notice-buttons">
                <!-- 버튼에 클릭 이벤트 추가 -->
                <button
                  v-for="(item, idx) in notice"
                  :key="idx"
                  :class="{ 'active-title': idx === activeSlideIndex }"
                  @click="goToSlide(idx)"
                >
                  {{
                    item.ntcTit.length > 5
                      ? item.ntcTit.slice(0, 5) + "..."
                      : item.ntcTit
                  }}
                </button>
              </div>

              <div class="swiper_inner">
                <swiper
                  class="swiper"
                  :options="swiperOptions"
                  ref="mySwiper"
                  @slideChange="onSlideChange"
                >
                  <swiper-slide v-for="(item, idx) in notice" :key="idx">
                    <a :href="item.ntcUrl" style="display: block">
                      <img :src="item.ntcImgFilePtUrl" :alt="item.ntcTit" />
                    </a>
                  </swiper-slide>
                </swiper>

                <div class="swiper_btn__group">
                  <button type="button" class="btn-pause" @click="togglePlay">
                    <span class="icon">
                      <svg
                        v-if="playing"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          width="32"
                          height="32"
                          transform="translate(2)"
                          fill="#1D1D1D"
                          style="
                            fill: #1d1d1d;
                            fill: color(display-p3 0.1137 0.1137 0.1137);
                            fill-opacity: 1;
                          "
                        />
                        <path
                          d="M14 10V22"
                          stroke="white"
                          style="stroke: white; stroke-opacity: 1"
                          stroke-width="2"
                          stroke-linecap="round"
                        />
                        <path
                          d="M22 10V22"
                          stroke="white"
                          style="stroke: white; stroke-opacity: 1"
                          stroke-width="2"
                          stroke-linecap="round"
                        />
                      </svg>

                      <svg
                        v-else
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          width="32"
                          height="32"
                          fill="#1D1D1D"
                          style="
                            fill: #1d1d1d;
                            fill: color(display-p3 0.1137 0.1137 0.1137);
                            fill-opacity: 1;
                          "
                        />
                        <path
                          d="M20.2463 16.1973L11.9035 22.6862C11.7393 22.8139 11.5 22.6969 11.5 22.4888L11.5 9.51116C11.5 9.30312 11.7393 9.1861 11.9035 9.31382L20.2463 15.8027C20.375 15.9028 20.375 16.0972 20.2463 16.1973Z"
                          stroke="white"
                          style="stroke: white; stroke-opacity: 1"
                          stroke-width="2"
                          stroke-linecap="round"
                        />
                      </svg>
                    </span>
                  </button>
                  <button type="button" class="btn-close2" @click="clickClose">
                    <i class="icon-close">
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          width="32"
                          height="32"
                          fill="#1D1D1D"
                          style="
                            fill: #1d1d1d;
                            fill: color(display-p3 0.1137 0.1137 0.1137);
                            fill-opacity: 1;
                          "
                        />
                        <path
                          d="M10.0001 10L22.0002 22.0001"
                          stroke="white"
                          style="stroke: white; stroke-opacity: 1"
                          stroke-width="2"
                          stroke-linecap="round"
                        />
                        <path
                          d="M22.0002 10L10.0001 22.0001"
                          stroke="white"
                          style="stroke: white; stroke-opacity: 1"
                          stroke-width="2"
                          stroke-linecap="round"
                        />
                      </svg>
                    </i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="popup-footer">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                v-model="noShow"
                id="chk"
              />
              <label for="chk" class="form-check-label"
                >오늘 하루 이창을 열지 않음</label
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MUT_CLOSE_COMMON_NOTICE_MODAL } from "../../store/_mut_consts";
import { ACT_GET_NOTICE } from "../../store/_act_consts";
import { getItems, lengthCheck } from "../../assets/js/utils";
import { swiperNoticePopOptions } from "../../assets/js/swiper.config";
import { mapGetters } from "vuex";

export default {
  name: "NotificationModal",
  computed: {
    ...mapGetters("auth", ["isAuth", "session", "profile", "creatorModal"]),
    running() {
      if (this.swiper) {
        return this.swiper.autoplay.running;
      } else {
        return null;
      }
    },
  },
  data: () => ({
    swiperOptions: {
      ...swiperNoticePopOptions(),
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      pauseOnMouseEnter: true,
      loop: true,
    },
    notice: [],
    noticeShow: false,
    noShow: false,
    playing: true,
    swiper: null,
    activeSlideIndex: 0, // 현재 활성 슬라이드 인덱스
  }),
  created() {
    this.$store
      .dispatch(`notice/${ACT_GET_NOTICE}`, {
        pageNo: 1,
        pageSize: 100, // 충분히 큰 pageSize로 모든 데이터 가져오기
      })
      .then((res) => {
        if (lengthCheck(res) && !this.$cookies.get("dh-notice-popup")) {
          this.notice = getItems(res); // 모든 공지사항 저장
        }
        if (this.notice.length > 1) {
          this.noticeShow = true;
        }
      })
      .catch((e) => {
        console.error("Failed to fetch notices:", e);
        this.notice = [];
      });
  },
  mounted() {
    this.swiper = this.$refs.mySwiper.$swiper;
  },
  beforeDestroy() {
    if (this.swiper) {
      this.swiper.autoplay.stop();
    }
  },
  methods: {
    clickClose() {
      if (this.noShow) {
        this.$cookies.set("dh-notice-popup", 1, "1d");
      }
      this.$store.commit(`notice/${MUT_CLOSE_COMMON_NOTICE_MODAL}`);
    },
    clickCloseToday() {
      this.$cookies.set("dh-notice-popup", 1, "1d");
    },
    togglePlay() {
      this.playing = !this.playing;
      if (this.playing) {
        this.swiper.autoplay.start();
      } else {
        this.swiper.autoplay.stop();
      }
    },
    onSlideChange() {
      this.activeSlideIndex = this.swiper.realIndex; // 슬라이드 변경 시 인덱스 업데이트
    },
    // 버튼 클릭 시 해당 슬라이드로 이동
    goToSlide(index) {
      this.swiper.slideToLoop(index); // loop 모드에서 사용 가능한 메서드
      this.activeSlideIndex = index; // 클릭 시 활성 인덱스 즉시 업데이트
      if (this.playing) {
        this.swiper.autoplay.start(); // 자동 재생 유지
      }
    },
  },
};
</script>

<style>
#popup-notice {
  top: -159px;
}
.layer-popup .popup-body .notice-buttons {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 16px;
}

#popup-notice-image .notice-buttons button {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 140px;
  height: 48px;
  padding: 10px 24px;
  padding: 10px 0px;
  background: #fff;
  color: #1d1d1d;
  border: 1px solid #c6c6c6;
  border-radius: 999px;
  font-size: 20px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  outline: none;
  box-sizing: border-box;
}

#popup-notice-image button.active-title {
  background: #008775;
  border: 1px solid #008775;
  color: #fff;
  font-weight: 700;
  font-size: 20px;
}

/* 재생/일시정지 버튼 스타일 */
.layer-popup .popup-body .btn-pause {
  width: 32px;
  height: 32px;
  cursor: pointer;
  z-index: 5;
}

.layer-popup .popup-body .icon {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
}

#popup-notice {
  max-height: 80vh;
  width: 500px !important;
  height: 500px !important;
}
.layer-popup {
  position: relative;
  text-align: center;
  margin: auto;
  width: 100%;
  border-radius: 30px;
  top: -18px;
}
.layer-popup .popup-body .swiper_btn__group {
  display: flex;
  align-items: center;
  position: absolute;
  right: 0;
  top: 64px;
}

.layer-popup .popup-body .swiper-button-next,
.layer-popup .popup-body .swiper-rtl .swiper-button-prev {
  right: 10px;
  left: auto;
  width: 56px;
  height: 56px;
  background: #fff;
  border-radius: 50%;
}

.layer-popup .popup-footer {
  display: flex;
  align-items: center;
  justify-content: center !important;
  gap: 10px;
  padding-top: 16px !important;
  margin: 0 !important;
  background: transparent !important;
}

#popup-notice .popup-footer .form-check-label {
  color: #fff !important;
  font-size: 18px !important;
}
.layer-popup .popup-footer .form-check {
  display: inline-flex;
  height: 40px;
  padding: 10px 24px;
  justify-content: center;
  align-items: center;
  gap: 16px;
  border-radius: 999px;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  background: #1d1d1d;
}

.layer-popup .swiper_btn__group .btn-close2 {
  position: relative;
  height: 32px;
  width: 32px;
  font-size: 0;
  background: #1d1d1d;
  z-index: 5;
}
.layer-popup .popup-body .swiper-button-next {
  transform: rotate(180deg);
}

.layer-popup .popup-body .layer-popup .popup-body {
  overflow-y: unset !important;
}

#popup-notice .icon-close {
  width: 32px !important;
  height: 32px !important;
  background-image: url(../../assets/svg/btn-close2.svg) !important;
}

@media screen and (max-width: 800px) {
  #popup-notice {
    display: flex;
    width: 100%;
    height: auto;
    padding: 20px;
    position: relative;
    top: -10px;
    flex-direction: column;
    justify-content: center;
    background: none;
  }
  #popup-notice .swiper_inner {
    position: relative;
  }

  #popup-notice-image .notice-buttons button {
    font-size: 16px;
    height: 48px;
  }

  #popup-notice .popup-footer {
    margin: 0;
    padding: 18px 0 0 0 !important;
    background-color: #fff;
    justify-content: center;
    display: flex;
    flex-direction: column;
  }

  .layer-popup .popup-body .swiper-button-next,
  .layer-popup .popup-body .swiper-button-prev {
    width: 32px !important;
    height: 32px !important;
    background-size: 100%;
  }
  .layer-popup .popup-body .icon {
    width: 32px;
  }
  .layer-popup .popup-body .btn-pause {
    width: 32px;
    height: 32px;
    background-size: 100%;
  }
  .layer-popup .popup-footer .form-check,
  .layer-popup .popup-footer .btn-close2 {
    font-size: 14px;
  }
  #popup-notice .popup-footer .form-check-label {
    font-size: 14px !important;
  }
  .layer-popup .popup-body .swiper_btn__group {
    top: 0;
  }
  .layer-popup .popup-body .form-check-input {
    width: 20px !important;
    height: 20px !important;
  }
  #popup-notice {
    width: 100% !important;
    height: 100% !important;
  }
}
</style>
